import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Optimizes an image URL from the Auxo CDN using Cloudflare on-the-fly resizing.
 * Avoids compression artifacts (zebra stripes/banding) by requesting high quality (90) and auto-format (AVIF/WebP).
 * 
 * @param {string} url - The original image URL
 * @param {number} width - Target width in pixels
 * @param {number} quality - Quality level (1-100)
 * @returns {string} The optimized image URL
 */
export function getOptimizedImageUrl(url, width = 1200, quality = 90) {
  if (!url || typeof url !== 'string' || !url.includes("assets.auxodev.dk")) return url;
  // If it already has cdn-cgi/image, don't double wrap
  if (url.includes("/cdn-cgi/image/")) return url;
  
  // Replace the domain with domain + cdn-cgi/image
  return url.replace(
    "https://assets.auxodev.dk/",
    `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=${quality},format=auto/`
  );
}
